<template>
	<div data-tour-scope="categories-list">
		<v-navigation-drawer fixed v-model="navStateOrder" app right class="mt-0 font treeviewHeight" style="top: 0; height: 100%; max-height: 100%; min-height: 40px !important" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.Order') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list>
				<v-list-item style="margin: 0; padding: 0">
					<template v-slot:default v-if="Array.isArray(getSettings.categories) && getSettings.categories && getSettings.categories.length > 0 && langDefault">
						<v-draggable-treeview v-model="getSettings.categories" class="treeview" data-tour="sort-tree">
							<template v-slot:label="{ item }">
								<span>{{ _.find(item.trans, { lang: langDefault }).name }}</span>
							</template>
							<template v-slot:append="{ item }">
								<template v-if="item.children && true && item.children.length > 0"> ({{ item.children.length }}) </template>
							</template>
						</v-draggable-treeview>
					</template>
				</v-list-item>
				<v-list-item>
					<v-btn block depressed color="primary" data-tour="sort-confirm" @click="confermaOrdinamento">
						<v-icon left> mdi-sort </v-icon>
						Conferma ordinamento
					</v-btn>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.categories') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="export">
											<v-icon>mdi-arrow-collapse-down</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item data-tour="export-csv" @click="exportAsync('categories', 'csv', { search: searchfield, categories: settings.filters.categories, selected: [] })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in CSV</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item @click="exportAsync('categories', 'excel', { search: searchfield, categories: settings.filters.categories, selected: [] })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>

								<v-btn text data-tour="sort" @click="toggleDrawerSort">
									<v-icon>mdi-sort</v-icon>
								</v-btn>
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item data-tour="add-category" @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi categoria</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item data-tour="add-file" @click="getFileCategories">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da file esterno</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<!--<v-list-item @click="getCategoryShopify" v-if="shopify">-->
										<v-list-item @click="importItemConfirmShopify" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da Shopify</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item @click="getCategoryMagento" v-if="magento">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da Magento</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4">
									<v-text-field
										data-tour="search"
										v-model="searchfield"
										label="Cerca"
										outlined
										append-icon="mdi-magnify"
										dense
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
										hide-details
									></v-text-field>
								</v-col>
								<v-col cols="12" md="8" data-tour="parent">
									<v-autocomplete hide-details="auto"
										outlined
										v-model="findParant"
										@change="filterCheck"
										@click:clear="filterCheck"
										:items="listcategories"
										label="Categorie"
										return-object
										item-value="_id"
										item-text="string"
										clearable
										dense
									>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getCategories"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni categoria diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="category-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="(item.trans && item.trans.name) || 'Categoria'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center mb-2">
													<span class="cat-label mr-2">Lingue</span>
													<LingueFlags :lingue="item.lingue" />
												</div>
												<div v-if="item.id !== 0" class="d-flex align-center justify-space-between" data-tour="status">
													<span class="cat-label">Attiva</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
													<!-- <v-list-item link @click="moveItem(item)">
                                                    <v-list-item-title class="size9">Sposta reference</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item link @click="copyItem(item)">
                                                    <v-list-item-title class="size9">Copia reference</v-list-item-title>
                                                </v-list-item>-->
												</v-list>
											</v-menu>
										</td>
										<td data-tour="status">
											<v-switch v-if="item.id !== 0" v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>

										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td>{{ item.id }}</td>

										<td>{{ item.trans.name }}</td>
										<td>{{ item.references }}</td>
										<td data-tour="langs"><LingueFlags :lingue="item.lingue" /></td>
										<!--td>{{ item.id }}</td-->

										<!--<td>{{ item.position }}</td>-->
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :value="getDialog" fullscreen hide-overlay eager transition="dialog-bottom-transition" persistent internal-activator no-click-animation :eager="true" :retain-focus="false">
			<FormFile v-if="operation === 'FormFile'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormFile>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la categoria non potrai più ripristinarla. I prodotti associati resteranno senza categoria </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmImport" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Verranno importate le categorie presenti su shopify non ancora inserite su azseller</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmImport = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="getCategoryShopify"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import { Category } from '@/utils/Category';

Vue.use(VuetifyDraggableTreeview);

// inserimento e modifica sono pagine; resta in dialog solo l'import da file esterno
const FormFile = () => import('@/components/categories/File.vue');

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import LingueFlags from '@/components/core/LingueFlags.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createCategoriesListTourSteps, stopCategoriesListTour } from './categories-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Categories',
	// pagina, righe, ordinamento, ricerca e categoria padre stanno nell'URL:
	// refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { categories: 'numberArray' }, perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita' da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createCategoriesListTourSteps(), { onStop: stopCategoriesListTour }),
		};
	},
	data() {
		return {
			menu: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',

			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					categories: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,

			searchfield: '',

			total: 0,

			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'is_active' },
				{ text: 'Created', value: 'created_at' },
				{ text: 'Id', value: 'id' },
				{ text: 'Categoria', value: 'trans.name' },
				{ text: 'Reference', value: 'references' },
				// una bandierina per lingua: a colori dove il nome c'e', in grigio dove manca
				{ text: 'Lingue', value: 'lingue', sortable: false },
			],
			listcategories: [],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',

			isMobile: false,

			operation: '',
			magento: false,
			shopify: false,
			langDefault: '',
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			dialogconfirmImport: false,
		};
	},

	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async created() {
		//this.setDialog(false)
		//this.initialize();

		this.setDialog(false);
		this.setExistFilter(true);
		this.listLoad();
		this.linkdownload = `${this.getUrl}nocors/categories/download`;

		let promises = [];
		promises.push(this.fetchSetting());
		promises.push(this.fetchService(['magento', 'shopify']));
		await Promise.all(promises);

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;

		this.items = this.getSettings.categories;

		var magento = _.find(this.getServices, { service: 'magento' });
		if (magento) {
			this.magento = magento.active;
		}
		var shopify = _.find(this.getServices, { service: 'shopify' });
		if (shopify) {
			this.shopify = shopify.active;
		}

		const category = new Category(this.getSettings.categories, this.langDefault);
		await category.buildTotal();
		await category.refactorCategory();
		await category.createPath();
		await category.dynamicSort();
		this.listcategories = await category.getTree;
		// filtro arrivato dall'URL: la tendina del padre lo mostra gia' scelto
		const padre = this.settings.filters.categories[0];
		if (padre !== undefined) {
			this.findParant = _.find(this.listcategories, { id: padre }) || [];
		}
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		LingueFlags,
		FormFile,
		TourOverlay,
		KeyValueCard,
		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'categories/getIndex',

			getCategories: 'categories/getCategories',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'categories/getSortBy',
			getSortDesc: 'categories/getSortDesc',
			getCategoriesTree: 'categories/getCategoriesTree',
			getCategoriesChildrean: 'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		// stessi dati delle colonne Created/Id/Reference della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Id', value: item.id },
				{ label: 'Creata', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Reference', value: item.references },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setCategories: 'categories/setCategories',
			setCategory: 'categories/setCategory',
			setIndex: 'categories/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'categories/asyncFetchData',
			fetchReports: 'orders/asyncFetchReportData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			getFetchCategoryMagento: 'categories/getCategoryMagento',
			getFetchCategoryShopify: 'categories/getCategoryShopify',

			getFetchNestedCategory: 'categories/getFetchNestedCategory',
			getNestedCategory: 'categories/getNestedCategory',
			getFetchTreeCategory: 'categories/getFetchTreeCategory',
			setUpdateStatusCategory: 'categories/setUpdateStatusCategory',
			deleteCategories: 'categories/deleteCategories',
			setupSort: 'categories/setupSort',
			//'fetchSetting': 'settings/asyncFetchData',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',
			fetchService: 'services/getServiceFetch',

			//'resetMessages' : 'settings/resetMessages'
		}),
		importItemConfirmShopify() {
			this.dialogconfirmImport = true;
		},
		async confirmFilter() {
			this.menu = false;
			await this.getDataFromApi();
		},
		async deleteChip(type, value) {
			switch (type) {
				case 'search':
					this.searchfield = '';
					this.settings.search = '';
					this.settings.options.page = 1;
					break;
				case 'category':
					this.settings.filters.categories = this.settings.filters.categories.filter(el => el !== value);
					this.settings.options.page = 1;
					break;
			}
			await this.getDataFromApi();
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia il filtro
		filterCheck(event) {
			this.settings.filters.categories = event ? [event.id] : [];
		},
		toggleDrawerFilter() {
			if (this.clippedOrder) {
				this.clippedOrder = 0;
			} else {
				this.setDrawerFilter(!this.getDrawerFilter);
			}
		},
		toggleDrawerSort() {
			if (this.getDrawerFilter) {
				this.setDrawerFilter(!this.getDrawerFilter);
			} else {
				this.clippedOrder = !this.clippedOrder;
			}
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},
		confermaOrdinamento() {
			try {
				this.setPreload(true);
				this.isActive = true;

				this.setupSort({ items: this.getSettings.categories }).then(result => {
					if (result.data.success) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				if (err.response) {
					let errors = err.response.data.error;
					if (errors) {
						errors.forEach(value => {
							this.messages[value.param] = value.msg;
						});
					}

					this.snackbar.color = 'error';
					this.snackbar.text = err.message;
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.preload = false;
					if (err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				}
			}
		},
		changeStatus(item) {
			try {
				this.setPreload(true);
				this.isActive = true;

				this.setUpdateStatusCategory({ _id: item._id, is_active: item.is_active }).then(result => {
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});
			} catch (err) {
				console.log(err);
			}
		},
		searchInto(parent) {
			var loop = _.map(_.filter(this.getCategoriesTree, { parent: { id: parent } }), 'id');

			if (_.size(loop) > 0) {
				_.forEach(loop, value => {
					this.arrayTree.push(value);
					this.searchInto(value);
				});
			}
			this.settings.filters.categories = this.arrayTree;
		},
		findArrayTree(parent) {
			this.arrayTree = [];
			//var start =this.arrayTree;
			var start = _.map(
				_.filter(this.getCategoriesTree, {
					parent: { id: parent },
					//&&level:2
				}),
				'id',
			);
			//console.log("start",start)
			_.forEach(start, value => {
				this.arrayTree.push(value);
				this.searchInto(value);
			});
		},
		chooseCategory(level) {
			switch (level) {
				case 1:
					if (this.settings.filters.firstlevel) {
						this.findArrayTree(this.settings.filters.firstlevel);
					} else {
						this.settings.filters.categories = [];
					}

					this.secondLevel = _.filter(this.getCategoriesTree, {
						parent: { id: this.settings.filters.firstlevel },
					});

					this.thirdLevel = [];
					this.fourthLevel = [];
					this.settings.filters.secondlevel = '';
					this.settings.filters.thirdlevel = '';
					this.settings.filters.fourthlevel = '';

					break;
				case 2:
					if (this.settings.filters.secondlevel) {
						this.findArrayTree(this.settings.filters.secondlevel);
					} else {
						this.findArrayTree(this.settings.filters.firstlevel);
					}

					this.thirdLevel = _.filter(this.getCategoriesTree, {
						parent: { id: this.settings.filters.secondlevel },
					});
					this.fourthLevel = [];

					this.settings.filters.thirdlevel = '';
					this.settings.filters.fourthlevel = '';

					break;
				case 3:
					if (this.settings.filters.thirdlevel) {
						this.findArrayTree(this.settings.filters.thirdlevel);
					} else {
						this.findArrayTree(this.settings.filters.secondlevel);
					}
					this.fourthLevel = _.filter(this.getCategoriesTree, {
						parent: { id: this.settings.filters.thirdlevel },
					});
					this.settings.filters.fourthlevel = '';

					break;
				case 4:
					if (this.settings.filters.fourthLevel) {
						this.findArrayTree(this.settings.filters.fourthLevel);
					} else {
						this.findArrayTree(this.settings.filters.thirdlevel);
					}
					break;
			}
		},
		async getCategoryMagento() {
			this.setPreload(true);
			await this.getFetchCategoryMagento();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Le categorie verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		async getCategoryShopify() {
			this.setPreload(true);
			await this.getFetchCategoryShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Le categorie verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale. Nell'URL va l'id numerico.
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/categories/${item.id}`);
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/categories/new');
		},
		async getFileCategories() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormFile';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
			//this.getDataFromApi();
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				let items = this.fetchItems(this.settings);
				items
					.then(result => {
						//console.log(result);
						this.total = result.total;
						//this.items = result.data.data
						this.setPreload(false);
					})
					.then(() => {});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    var response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},

		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			this.setPreload(true);
			this.messages = [];
			// solo la categoria scelta dai tre puntini: niente piu' eliminazione multipla
			const paypload = this.form ? [this.form] : [];

			this.deleteCategories(paypload)
				.then(data => {
					this.setPreload(false);
					this.updateData(data.data);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					});

					// console.log(data)
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.category-cards,
.category-cards tr {
	display: block;
	width: 100%;
}
.category-cards tr,
.category-cards tr:hover {
	background: transparent !important;
}
.category-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.category-cards tr:first-child td {
	padding-top: 12px !important;
}
.category-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.cat-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
